import { Flex, Box, Center, Image } from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import { keyframes } from "@emotion/react";

const Hero = () => {
  const [currentColor, setCurrentColor] = useState("white");
  const colors = ["#00FFA3", "#03E1FF", "#DC1FFF", "#FFFFFF"]; // Colors to sample through
  const transitionDuration = 2000;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentColor((prevColor) => {
        const currentIndex = colors.indexOf(prevColor);
        const nextIndex = (currentIndex + 1) % colors.length;
        const nextColor = colors[nextIndex];
        return nextColor;
      });
    }, transitionDuration);

    return () => {
      clearInterval(interval);
    };
  }, [colors]);

  const pulseAnimation = keyframes`
    0% {
      opacity: 1;
    }
    30% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  `;

  return (
    <div>
      <Flex
        mt={{ base: "40px", md: "120px" }}
        alignItems="center"
        justifyContent="center"
        w="100%"
      >
        <Box
          w={{ base: "90%", md: "60%" }}
          fontWeight="600"
          fontSize={{ base: "40px", md: "70px" }}
          lineHeight={{ base: "50px", md: "70px" }}
          textAlign="center"
        >
          Check the{" "}
          {/*    <Box
            as="span"
            display="inline-block"
            mr={{ base: "0px", md: "0px" }}
            ml={{ base: "0px", md: "0px" }}
            animation={`${pulseAnimation} 5s infinite, colorChange ${transitionDuration}ms infinite`}
            style={{
              color: currentColor,
            }}
          > */}
          <Box
            as="span"
            display="inline-block"
            mr={{ base: "0px", md: "0px" }}
            ml={{ base: "0px", md: "0px" }}
            animation={`${pulseAnimation} 5s infinite, colorChange ${transitionDuration}ms infinite`}
            bgGradient="linear(to-l, #00FFA3, #03E1FF, #DC1FFF)"
            bgClip="text"
          >
            pulse
          </Box>{" "}
          of your investments.
        </Box>
      </Flex>

      <Center
        style={{
          position: "relative",
          transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
        }}
        mt="60px"
      >
        <Box
          position="absolute"
          zIndex="0"
          w="50%"
          h="50%"
          backgroundImage="conic-gradient(from 45deg, #00FFA3, #03E1FF, #DC1FFF)"
          borderRadius="20px"
          filter="blur(100px)"
        />
        <Image
          pt="-2px"
          borderRadius="20px"
          boxSize={{ base: "90%", md: "70%" }}
          src="https://i.imgur.com/qDOuR01.png"
          zIndex="2"
          position="relative"
        />
      </Center>
    </div>
  );
};

export default Hero;
